module.exports = __webpack_public_path__ + "img/20190921103903360截图20190921095718298.e35013d7.jpg";